import React, { createContext, useContext, useReducer, useCallback } from 'react';

const CartContext = createContext();

const initialState = {
  selections: []
};

function cartReducer(state, action) {
  switch (action.type) {
    case 'ADD_SELECTION':
      // Prevent duplicates (same event + same team + same market)
      const exists = state.selections.find(
        s => s.eventId === action.payload.eventId
          && s.team === action.payload.team
          && (s.market || 'h2h') === (action.payload.market || 'h2h')
      );
      if (exists) return state;
      return {
        ...state,
        selections: [...state.selections, { ...action.payload, id: Date.now() }]
      };

    case 'REMOVE_SELECTION':
      return {
        ...state,
        selections: state.selections.filter(s => s.id !== action.payload)
      };

    case 'CLEAR_CART':
      return { ...initialState };

    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const [state, dispatch] = useReducer(cartReducer, initialState);

  const addSelection = useCallback((selection) => {
    dispatch({ type: 'ADD_SELECTION', payload: selection });
  }, []);

  const removeSelection = useCallback((id) => {
    dispatch({ type: 'REMOVE_SELECTION', payload: id });
  }, []);

  const clearCart = useCallback(() => {
    dispatch({ type: 'CLEAR_CART' });
  }, []);

  const value = {
    selections: state.selections,
    addSelection,
    removeSelection,
    clearCart,
    selectionCount: state.selections.length
  };

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
}
